import { fromEvent } from 'rxjs';
import { filter, subscribeOn } from 'rxjs/operators';

import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import { SLIDE } from '@bp/shared/animations';
import { MediaService } from '@bp/shared/features/media';
import { attrBoolValue } from '@bp/shared/utilities';
import { Destroyable, takeUntilDestroyed } from '@bp/shared/models/common';
import { BpScheduler } from '@bp/shared/rxjs';

@Component({
	selector: 'bp-submenu-item',
	templateUrl: './submenu-item.component.html',
	styleUrls: [ './submenu-item.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [ SLIDE ],
})
export class SubmenuItemComponent extends Destroyable implements OnInit {

	@Input() itemName!: string;

	@Input() popupClassPrefix!: string;

	@Input() dropdownMode!: boolean | '';

	@ViewChild(MatMenuTrigger) submenuTrigger?: MatMenuTrigger;

	opened = false;

	constructor(private readonly _media: MediaService) {
		super();

		this._closeSubmenuDropdownOnMobiles();

		this._closeSubmenuDropdownOnScroll();
	}

	ngOnInit(): void {
		this.dropdownMode = attrBoolValue(this.dropdownMode);
	}

	private _closeSubmenuDropdownOnMobiles(): void {
		this._media.lessThan$('Laptop')
			.pipe(takeUntilDestroyed(this))
			.subscribe(() => this.submenuTrigger?.closeMenu());
	}

	private _closeSubmenuDropdownOnScroll(): void {
		fromEvent(window, 'scroll')
			.pipe(
				subscribeOn(BpScheduler.outside),
				filter(() => !!this.submenuTrigger?.menuOpened),
				takeUntilDestroyed(this),
			)
			.subscribe(() => this.submenuTrigger?.closeMenu());
	}

}
